export default __webpack_public_path__ + "static/media/pic2.6491a575.jpg";